export const installmentBanks = {
  get_all: "products/audit/installment-banks/",
  create: "products/audit/installment-banks/",
  get_by_id: (id: number) =>
    `products/audit/installment-banks/get-by/?id=${id}`,
  edit: (id: number) => `products/audit/installment-banks/?id=${id}`,
  delete: (id: number) => `products/audit/installment-banks/?id=${id}`,
};
